export default __webpack_public_path__ + "static/media/address_icon.334657a4.svg";